<template>
    <div class="wrap">
        <div class="content" id="content">
            
            <div class="con" v-for="index in 7">
                <img :src="'https://appd.knowbox.cn/ss/activity/parent_frontend/member/june/0'+index+'.png'" />
            </div>
            <div class="mask" v-if="showPopup"></div>
        </div>

        <div class="button" @click="openPopup"></div>

        <div class="popup member_and" ref="popup" v-show="showPopup">
            <meal 
                :Info="Info" 
                source="and" 
                v-if="!Info.needUpgrade"
                ref="meal"
                @popupClosed="closePopup"
            ></meal>
        </div>
    </div>
</template>

<script>
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import {isIOS, isAndroid} from "@/utils/env";
import NoPayPopUp from "./no_pay_popup";
import Meal from "./member_meal_new";
import {hideTitleBar} from '@/utils/hybird';

const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
const categoryId = utils.getQueryString('categoryId');
const pageChannelId = utils.getQueryString('pageChannel');
const productId = utils.getQueryString('productId');    //商品Id

var vm = null;
window.jsCallback = function(res) {
    if(res == 'cancel') {
        vm.showFailToast = true;
    }else {
        window.location.href = 'hybird://method/exit';
    }
}

export default {
    name: "",
    components: {
        NoPayPopUp,
        Meal
    },
    data() {
        return {
            showPopup: false,
            showFailToast: false,       // 支付取消、失败弹框
            showIf: false,
            Info: {
                memberInfo: {
                    isMember: 1, // 是否是会员 1是 0否
                    username: "xxx",
                    memberDesc: "开通会员 全场免费学",// 会员信息描述
                },
                needUpgrade: 1,// 是否升级,1是 0否,如果是1时
                superMember: 12,// 超级会员时间,单位天
                syncTest: 124,// 同步练会员时间,单位天
                freeDays: 123,// 升级时免费天数
                memberProductList:[ // needUpgrade=1时此字段只有升级对应产品
                    {
                        "productId": 993,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":1,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 994,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":1,// 是否有价格比对
                    },
                    {
                        "productId": 995,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 996,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                    {
                        "productId": 997,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                    },
                ]
            },
            scrollTop: 0
        }
    },

    methods: {
        async getInfo() {
            const [resp] = await ajax.all([
                ajax.get('/pay/common/member-sale-page', {
                    params: {
                        token,
                        version,
                        source
                    }       
                })
            ])
            if(resp.data.code == 99999){
                console.log(resp.data);
                this.Info = resp.data.data;
                this.showIf = true;

                if(this.Info.needUpgrade){
                    gio('track', 'vipUpdatePage_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx912')
                }else{
                    gio('track', 'vipOpenPgae_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx910')
                }
            }
        },
        closePop() {
            this.showFailToast = false;
        },
        goPay() {
            this.Info.needUpgrade ? this.$refs.mealUpdate.goPay('cancelPop') : this.$refs.meal.goPay('cancelPop');    
        },
        getGioParams(){
            return {
                categoryId,
                pageChannelId,
                isVip: this.Info.memberInfo.isMember,
                productId,
            }
        },

        pageScrollTop() {
            if (document.scrollingElement) {
                return document.scrollingElement.scrollTop
            }

            return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
        },

        openPopup() {
            let cEle = document.getElementById('content');
            this.showPopup = true;
            // document.body.style.height = '100%';
            // document.body.style.overflow = 'hidden';
            this.scrollTop = this.pageScrollTop();
            cEle.style.top = '-' + this.pageScrollTop() + 'px';
            cEle.style.position = 'fixed';
            
        

            let wH = window.innerHeight;
            let popup = this.$refs.popup;
            this.$nextTick(() => {
                popup.style.marginTop = wH - popup.clientHeight + this.pageScrollTop() + 'px';
            });
        },

        closePopup() {
            let cEle = document.getElementById('content');
            this.showPopup = false;
            // document.body.style.height = 'auto';
            // document.body.style.overflow = 'auto';
            
            cEle.style.position = 'absolute';
            cEle.style.top = 0 + 'px';
            document.body.scrollTop = this.scrollTop;
            
        }
    },
    created() {
        this.getInfo();
        vm = this;
    },

    mounted() {
        // hideTitleBar(0);
    }
}
</script>

<style lang="scss" scoped>

.member_and {
    text-align: center;
    font-family: PingFangSC-Medium;    
}

.stop-scroll {
    height: 100%;
    overflow: hidden;
}

.content {
    position: absolute;
    top: 0;
    left: 0;
    .con {
        position: relative;
        .listen {
            position: absolute;
            right: 1rem;
            top: 0;
            width: 1.56rem;
            height: .76rem;
            position: absolute;
            right: 1.5rem; 

            &.l-01 {
                top: 3.6rem;
            }
            &.l-02 {
                top: 3.8rem;
            }
            &.l-03 {
                top: 4.5rem;
            }
            &.l-04 {
                top: 2.8rem;
            }
        }
    }
    img {
        width: 100%;
        display: block;
    }
    .mask {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .6);
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.button {
    background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/landing/btn.png) no-repeat;
    width: 100%;
    height: 1.2rem;
    background-size: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
}
</style>